import { render } from "./AssetRecipientList.vue?vue&type=template&id=70fdb06a&scoped=true"
import script from "./AssetRecipientList.vue?vue&type=script&lang=js"
export * from "./AssetRecipientList.vue?vue&type=script&lang=js"

import "./AssetRecipientList.vue?vue&type=style&index=0&id=70fdb06a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70fdb06a"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QInput,QIcon,QBtn,QTd,QCheckbox,QTooltip,QSpinner,QDialog,QCard,QCardSection,QCardActions,QBar,QSpace,QBanner,QList,QItem,QInnerLoading});qInstall(script, 'directives', {ClosePopup});
